import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, ParamMap, Router, RouterModule } from '@angular/router';
import { Location } from '@angular/common';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { SafePipe } from 'src/app/utils/safe.pipe';


@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],


})
export class AdministrationComponent implements OnInit, OnDestroy {
  selectedItem: string = '';
  items = [
    { "Name": 'Governing Body', "Url": 'governing-body', },
    { "Name": 'Message of Chief Patron', "Url": 'message-of-chief-patron', },
    { "Name": 'Message of Chairman', "Url": 'message-of-chairman', },
    { "Name": 'Message of Principal', "Url": 'message-of-principal', },
    { "Name": 'Message of Vice Principal(College)', "Url": 'message-of-vice-principal-college', },
    { "Name": 'Message of Vice Principal (English Version)', "Url": 'message-of-vice-principals-english-version', },
    { "Name": 'Message of Vice Principal (Bangla Version)', "Url": 'message-of-vice-principal-bangla-version', },
  ];
  imageLoaded = false;
  fetchinData = true;
  ImageAlbums: any;
  GBs: any;
  GBs1: any;
  GBs2: any;
  TeacherInfo: any;
  StaffInfo: any;
  GBms: any;
  GBms1: any;
  selectedItemName = '';
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private location: Location, private appService: AppService, private router: Router, private _changeDetectorRef: ChangeDetectorRef,) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const item = params.get("item");
      const matchedItem = this.items.find(i => i.Url === item);
      if (item && matchedItem && item == matchedItem.Url) {
        this.selectedItem = item;
        this.selectedItemName = matchedItem.Name

      } else {
        this.selectedItem = this.items[0].Url;
        this.selectedItemName = this.items[0].Name
        this.location.replaceState(`/${this.selectedItem}`);
      }
      this.FetchData();
      this._changeDetectorRef.markForCheck();
    });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchData() {
    this._changeDetectorRef.markForCheck();
    this.fetchinData = true;
    if (this.selectedItem === 'governing-body') {
      this.FetchGbs();
    } else if (this.selectedItem === 'teacher-information' || this.selectedItem === 'staff-information') {
      this.FetchTeacherInfo();
    } else {
      this.FetchGbms();
    }
  }

  selectItem(item: string) {
    this.selectedItem = item;
    if (this.selectedItem === 'governing-body' || this.selectedItem === 'teacher-information' || this.selectedItem === 'staff-information') {
      this.router.navigate([`/administration/${item}`]);
    } else {
      this.location.go(`/administration/${item}`);
      if (this.GBms != null) {

        const matchedItem = this.items.find(i => i.Url === item);
        this.selectedItemName = matchedItem.Name;

        let gm = null;

        if (this.selectedItem === 'message-of-chairman') {
          gm = this.GBms.filter(item => item.GBDesignationId == 4 || (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chairman')));
        } else if (this.selectedItem === 'message-of-chief-patron') {
          gm = this.GBms.filter(item => item.GBDesignationId == 1 || (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chief patron')));
        } else if (this.selectedItem === 'message-of-principal') {
          gm = this.GBms.filter(item => item.GBDesignationId == 6 || (item.GBDesignation && item.GBDesignation.toLowerCase() === 'principal'));
        }
        else if (this.selectedItem === 'message-of-vice-principal-college') {
          gm = this.GBms.filter(item => item.GBDesignationId == 12 || item.GBDesignationId == 115 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('college') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        else if (this.selectedItem === 'message-of-vice-principals-english-version') {
          gm = this.GBms.filter(item => item.GBDesignationId == 116 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('english version') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        else if (this.selectedItem === 'message-of-vice-principal-bangla-version') {
          gm = this.GBms.filter(item => item.GBDesignationId == 117 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('bangla version') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        this.GBms1 = gm && gm.length > 0 ? gm[0] : null;
      }
      else {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        this.FetchGbms();
      }

    }
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  FetchGbs() {
    forkJoin([
      this.appService.getGBs(),
    ]).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        console.log(response, 'response Albums');

        const allGBs = Array.isArray(response[0].data) ? response[0].data : [];
        const excludedRoles = [
          'eleven admission help desk',
          'information service centre',
          'complaint and resolution officer',
          'leadership'
        ];

        this.GBs = allGBs.filter((item: any) => {
          const designation = (item?.GBDesignation || '').toLowerCase().trim();
          const position = (item?.GBPosition || '').toLowerCase().trim();
          const id = item?.GBDesignationId;

          if (id === 104 || id === 105 || id === 113) return false;
          if (excludedRoles.includes(designation) || excludedRoles.includes(position)) return false;

          return true;
        });

        if (this.GBs && this.GBs.length > 0) {
          let m1 = this.GBs.slice(0, 1);
          this.GBs1 = m1[0];
          this.GBs2 = this.GBs.slice(1);
        }

        this.fetchinData = false;
        this._changeDetectorRef.markForCheck();
      });
  }

  FetchTeacherInfo() {
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).subscribe((response: any) => {
      console.log(response, 'response Albums');

      const allData = response[0].data || [];
      this.TeacherInfo = allData.filter((x: any) => {
        const arena = (x.JobArena || x.jobArena || '').toString().trim().toLowerCase();
        return arena === 'college';
      });
      this.StaffInfo = allData.filter((x: any) => {
        const arena = (x.JobArena || x.jobArena || '').toString().trim().toLowerCase();
        return arena === 'office';
      });
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }

  FetchGbms() {
    forkJoin([
      this.appService.getGBMessages(),
    ]).subscribe((response: any) => {
      console.log(response, 'response Albums');

      this.GBms = response[0].data;

      if (this.GBms) {

        let gm = null;

        if (this.selectedItem === 'message-of-chairman') {
          gm = this.GBms.filter(item => item.GBDesignationId == 4 || (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chairman')));
        } else if (this.selectedItem === 'message-of-chief-patron') {
          gm = this.GBms.filter(item => item.GBDesignationId == 1 || (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chief patron')));
        } else if (this.selectedItem === 'message-of-principal') {
          gm = this.GBms.filter(item => item.GBDesignationId == 6 || (item.GBDesignation && item.GBDesignation.toLowerCase() === 'principal'));
        }
        else if (this.selectedItem === 'message-of-vice-principal-college') {
          gm = this.GBms.filter(item => item.GBDesignationId == 12 || item.GBDesignationId == 115 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('college') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        else if (this.selectedItem === 'message-of-vice-principals-english-version') {
          gm = this.GBms.filter(item => item.GBDesignationId == 116 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('english version') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        else if (this.selectedItem === 'message-of-vice-principal-bangla-version') {
          gm = this.GBms.filter(item => item.GBDesignationId == 117 || ((item.GBDesignation || item.GBDesignationName) && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('bangla version') && (item.GBDesignation || item.GBDesignationName).toLowerCase().includes('vice principal')));
        }
        this.GBms1 = gm && gm.length > 0 ? gm[0] : null;
      }

      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }

  TransformUrl(value) {
    if (value.includes('https://')) {
      return value;
    }
    else {
      return `https://${value}`
    }
  }

  formatMessageTitle(name: string): string {
    if (!name) return 'MESSAGE';
    let clean = name.trim();
    if (clean.toLowerCase().startsWith('message of ')) {
      let role = clean.substring(11).trim();
      return `${role}'S MESSAGE`.toUpperCase();
    }
    return clean.toUpperCase();
  }
}
